import Vue from "vue";
import Router from "vue-router";
import md5 from "js-md5";
import { MessageBox } from "element-ui";
import store from "../vuex/store";

import Home from "@/pages/home";
//商品展示
import Index from "@/pages/goods/index";
import Goodslist from "@/pages/goods/goodslist";
import Detail from "@/pages/goods/detail";
import { userInfo } from "os";
//个人
import User from "@/pages/user/index";
import Myorder from "@/pages/user/cont/myorder";
import Orderdetail from "@/pages/user/cont/orderdetail";
import Orderlist from "@/pages/user/cont/Orderlist";
import Mypoints from "@/pages/user/cont/mypoints";
import Buypoints from "@/pages/user/cont/buypoints";
import Buypointsrecord from "@/pages/user/cont/buypointsrecord";
import Mycollect from "@/pages/user/cont/mycollect";
import Presented from "@/pages/user/cont/presented";
import Recharge from "@/pages/user/cont/recharge";
import Personal from "@/pages/user/cont/personal";
import Password from "@/pages/user/cont/password";
import Feedback from "@/pages/user/cont/feedback";
import Address from "@/pages/user/cont/address";
// import Records from '@/pages/user/cont/record'
//订单
import Cart from "@/pages/affirmOrder/cart";
import AffirmOrder from "@/pages/affirmOrder/index";
import Ordersucceed from "@/pages/affirmOrder/ordersucceed";
import OrdersucceedWx from "@/pages/affirmOrder/OrdersucceedWx";

//登录
import Login from "@/pages/login/index";
import FindPassword from "@/pages/login/findpassword";
//404
import Error from "@/pages/activity/error";
import Over from "@/pages/activity/over";
import Overtime from "@/pages/activity/overtime";
Vue.use(Router);
var root = process.env.API_ROOT;
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      redirect: "/index",
      //重定向 默认显示子组件
      children: [
        {
          name: "Index",
          path: "/index",
          component: Index,
          meta: {
            keepAlive: true
          }
        },
        {
          name: "Goodslist",
          path: "/goodslist",
          component: Goodslist,
          meta: {
            keepAlive: false
          }
        },
        {
          name: "Detail",
          path: "/detail/:id",
          component: Detail,
          meta: {
            keepAlive: false
          }
        },
        {
          name: "User",
          path: "/user",
          component: User,
          redirect: "/user/myorder",
          children: [
            {
              name: "Myorder",
              path: "/user/myorder",
              component: Myorder,
              redirect: "/user/myorder/orderlist",
              children: [
                {
                  name: "Orderlist",
                  path: "/user/myorder/orderlist",
                  component: Orderlist,
                  meta: {
                    keepAlive: false
                  }
                }
              ]
            },
            {
              name: "Orderdetail",
              path: "/user/Orderdetail/:id/:status",
              component: Orderdetail,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Mypoints",
              path: "/user/mypoints",
              component: Mypoints,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Buypoints",
              path: "/user/buypoints",
              component: Buypoints,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Buypointsrecord",
              path: "/user/buypointsrecord",
              component: Buypointsrecord,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Mycollect",
              path: "/user/mycollect",
              component: Mycollect,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Recharge",
              path: "/user/recharge",
              component: Recharge,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Presented",
              path: "/user/presented",
              component: Presented,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Personal",
              path: "/user/personal",
              component: Personal,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Password",
              path: "/user/password",
              component: Password,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Feedback",
              path: "/user/feedback",
              component: Feedback,
              meta: {
                keepAlive: false
              }
            },
            {
              name: "Address",
              path: "/user/address",
              component: Address,
              meta: {
                keepAlive: false
              }
            }
            // {

            //   name: 'Records',
            //   path: '/user/record',
            //   component: Records,
            //   meta: {
            //     keepAlive: false
            //   }
            // }
          ]
        }
      ]
    },
    {
      name: "AffirmOrder",
      path: "/affirmorder/:id_cfir",
      component: AffirmOrder,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "Ordersucceed",
      path: "/ordersucceed/:ordersn",
      component: Ordersucceed,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "OrdersucceedWx",
      path: "/ordersucceedwx",
      component: OrdersucceedWx,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "Cart",
      path: "/cart",
      component: Cart,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "Login",
      path: "/login/:type",
      component: Login,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "FindPassword",
      path: "/findpassword",
      component: FindPassword,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "Error",
      path: "*",
      component: Error,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "Over",
      path: "/over",
      component: Over,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "Overtime",
      path: "/overtime",
      component: Overtime,
      meta: {
        keepAlive: false
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (store.state.webInfo.switch_status != 0 && to.name != "FindPassword") {
    store.commit("webInfo");
    store.commit("tonggao");
  }
  //判断是否关闭商城
  if (store.state.webInfo.switch_status == 0 && to.name != "Over") {
    router.push({ name: "Over" });
    return false;
  }
  //判断是否允许游客访问
  if (
    store.state.webInfo.visitor_status == 0 &&
    store.state.user_id == "null" &&
    to.name != "Login" &&
    store.state.webInfo.switch_status != 0 &&
    to.name != "FindPassword"
  ) {
    router.push({ name: "Login", params: { type: 1 } });
    return false;
  }
  //判断是否在积分卡充值页面
  // console.log(to.name)
  // console.log(store.state.webInfo.card_status)
  // console.log(store.state)
  // console.log(store.state.webInfo)
  // console.log(typeof(store.state.webInfo.card_status))
  if (to.name == "Recharge") {
    if (store.state.webInfo.card_status == 0) {
      router.push({ name: "Error" });
      return false;
    }
    // next()
  }
  //判断是再在商品列表页
  if (from.name == "Goodslist") {
    document.title = store.state.webInfo.name; //商城名称
  }
  const nextRoute = [
    "User",
    "Myorder",
    "Orderlist",
    "Mypoints",
    "Buypoints",
    "Mycollect",
    "Presented",
    "Personal",
    "Password",
    "Feedback",
    "Address",
    "AffirmOrder",
    "Ordersucceed",
    "Cart",
    "Orderdetail"
  ];
  if (nextRoute.indexOf(to.name) >= 0) {
    console.log(121111222222);
    if (store.state.id_example == "") {
      console.log(121111223333);
      setTimeout(() => {
        var ts = new Date($.ajax({ url: "/", type: "OPTIONS", async: false }).getResponseHeader("Date"));
        ts = new Date(ts).getTime();
        ts = ts / 1000;
        console.log("ts1", ts);
        var apiKey = "1106e4d408248208";
        var securityKey = "D5695EBCCF795D68";
        var sign = md5(
          md5(
            "apiKey=" +
              apiKey +
              "securityKey=" +
              securityKey +
              "timeStamp=" +
              ts
          )
        );
        if (store.state.user_id == "") {
          store.state.user_id = "null";
        }
        $.ajax({
          type: "post",
          url: root + "/user/user/info",
          data: {
            id_example: store.state.id_example,
            token_user: store.state.user_id,
            timeStamp: ts,
            apiKey: apiKey,
            sign: sign
          },
          success: function(res) {
            console.log("res23232", res);
            if (typeof res == "string") {
              if (JSON.parse(res).code == -100) {
                MessageBox.confirm("用户未登录请重新登录", "提示", {
                  beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                      router.push({ name: "Login", params: { type: 1 } });
                      done();
                    } else {
                      done();
                    }
                  }
                });
              } else if (JSON.parse(res).code == -101) {
                MessageBox.confirm("登录超时请重新登录", "提示", {
                  beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                      router.push({ name: "Login", params: { type: 1 } });
                      done();
                    } else {
                      done();
                    }
                  }
                });
              }
            } else if (res.code == "-100") {
              console.log("33333333333");
              MessageBox.confirm("用户未登录请重新登录", "提示", {
                beforeClose: (action, instance, done) => {
                  if (action === "confirm") {
                    router.push({ name: "Login", params: { type: 1 } });
                    done();
                  } else {
                    done();
                  }
                }
              });
            } else if (res.code == "-101") {
              MessageBox.confirm("登录过期请重新登录", "提示", {
                beforeClose: (action, instance, done) => {
                  if (action === "confirm") {
                    router.push({ name: "Login", params: { type: 1 } });
                    done();
                  } else {
                    done();
                  }
                }
              });
            } else if (res.code == "100") {
              next();
            }
          }
        });
      }, 100);
    } else {
      var ts = new Date($.ajax({ url: "/", type: "OPTIONS", async: false }).getResponseHeader("Date"));
      console.log("time111", ts);
      ts = new Date(ts).getTime();
      ts = ts / 1000;
      console.log("ts1111", ts);
      var apiKey = "1106e4d408248208";
      var securityKey = "D5695EBCCF795D68";
      var sign = md5(
        md5(
          "apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts
        )
      );
      if (store.state.user_id == "") {
        store.state.user_id = "null";
      }
      $.ajax({
        type: "post",
        url: root + "/user/user/info",
        data: {
          id_example: store.state.id_example,
          token_user: store.state.user_id,
          timeStamp: ts,
          apiKey: apiKey,
          sign: sign
        },
        success: function(res) {
          console.log("res23232", res);
          if (typeof res == "string") {
            if (JSON.parse(res).code == -100) {
              MessageBox.confirm("用户未登录请重新登录", "提示", {
                beforeClose: (action, instance, done) => {
                  if (action === "confirm") {
                    router.push({ name: "Login", params: { type: 1 } });
                    done();
                  } else {
                    done();
                  }
                }
              });
            } else if (JSON.parse(res).code == -101) {
              MessageBox.confirm("登录过期请重新登录", "提示", {
                beforeClose: (action, instance, done) => {
                  if (action === "confirm") {
                    router.push({ name: "Login", params: { type: 1 } });
                    done();
                  } else {
                    done();
                  }
                }
              });
            }
          } else if (res.code == "-100") {
            MessageBox.confirm("用户未登录请重新登录", "提示", {
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  router.push({ name: "Login", params: { type: 1 } });
                  done();
                } else {
                  done();
                }
              }
            });
          } else if (res.code == "-101") {
            MessageBox.confirm("登录过期请重新登录", "提示", {
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  router.push({ name: "Login", params: { type: 1 } });
                  done();
                } else {
                  done();
                }
              }
            });
          } else if (res.code == "100") {
            next();
          }
        }
      });
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js